module.exports = __webpack_public_path__ + "img/icon-sub-account-number@2x.7ab13bc7.png";